<template>
  <div @click="showDetails = !showDetails">
    <vs-row
      class="cartCard"
      :class="cartContent.length > 0 ? 'cartHasItem' : ''"
      style="min-width: 320px; max-width: 100%"
    >
      <vs-row vs-type="flex" vs-align="center">
        <vs-icon color="primary" icon="shopping_cart"></vs-icon>
        <vs-button style="margin-left: 5px" color="dark" type="flat" disabled size="default">
          {{ cartContent.length }}
        </vs-button>
        <span>|</span>
        <vs-button style="margin-left: 2px" color="dark" type="flat" disabled size="default">
          <animated-number
            :duration="300"
            :formatValue="formatToPrice"
            :value="customerData.customerTotal"
          ></animated-number>
        </vs-button>
      </vs-row>
    </vs-row>

    <div class="centerx">
      <vs-popup title="Kosár tartalma" :active.sync="showDetails">
        <div v-if="cartContent.length > 0">
          <ul>
            <li v-for="(cartItem, cartIndex) in cartContent" :key="cartIndex">
              <vs-row type="flex" vs-jutify="space-between">
                <vs-col vs-w="6" vs-justify="flex-start" vs-align="center" vs-type="flex">
                  <h5>{{ cartItem.ItemQty }} x {{ cartItem.ItemName }}</h5>
                </vs-col>
                <vs-col vs-w="6" vs-justify="flex-end" vs-align="center" vs-type="flex">
                  <animated-number
                    class="priceTag"
                    :formatValue="formatToPrice"
                    :value="getPrice(cartItem)"
                    :duration="300"
                  />
                  <vs-button
                    class="cartButton"
                    radius
                    icon="exposure_plus_1"
                    color="success"
                    type="gradient"
                    size="small"
                    @click="cartItem.ItemQty++"
                  ></vs-button>
                  <vs-button
                    class="cartButton"
                    radius
                    icon="exposure_neg_1"
                    color="warning"
                    type="gradient"
                    size="small"
                    @click="decrement(cartIndex)"
                  ></vs-button>
                  <vs-button
                    class="cartButton"
                    radius
                    icon="cancel"
                    color="danger"
                    type="gradient"
                    size="small"
                    @click="deleteFromCart(cartIndex)"
                  ></vs-button>
                </vs-col>
              </vs-row>
              <vs-row style="padding-left: 15px" v-for="(addon, addonIndex) in cartItem.ItemAddons" :key="addonIndex">
                <vs-col vs-w="6" vs-justify="flex-start" vs-align="center" vs-type="flex">
                  <h6>+ {{ addon.AddonName }}</h6>
                </vs-col>
                <vs-col vs-w="6" vs-justify="flex-end" vs-align="center" vs-type="flex">
                  <animated-number
                    class="priceTag"
                    style="font-size: 13px"
                    :formatValue="formatToPrice"
                    :value="addon.AddonPrice"
                    :duration="300"
                  />
                  <vs-button
                    class="cartButton"
                    radius
                    icon="cancel"
                    color="danger"
                    type="gradient"
                    size="small"
                    @click="deleteAddon(cartIndex, addonIndex)"
                  ></vs-button>
                </vs-col>
              </vs-row>
            </li>
          </ul>
          <vs-row>
            <vs-divider color="success" icon="arrow_downward"></vs-divider>
            <vs-col vs-w="6" vs-type="flex" vs-justify="flex-start">
              <strong>Összesen:</strong>
            </vs-col>
            <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
              <strong>
                <animated-number :duration="300" :formatValue="formatToPrice" :value="getTotalPrice()" />
              </strong>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12" vs-type="flex" vs-justify="center">
              <vs-button @click="placeOrder()"> Megrendelem </vs-button>
            </vs-col>
          </vs-row>
        </div>
        <div v-else>
          <h3>A kosár üres.</h3>
        </div>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup title="Megrendelés véglegesítése" :active.sync="orderDetails">
        <vs-row vs-justify="left">
          <vs-col>
            <h4>Megrendelő adatai</h4>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="8" vs-type="flex" vs-justify="center" vs-align="center">
            <vs-input
              autofocus
              v-model="customerData.customerName"
              label="Megrendelő neve"
              danger-text="A név megadása kötelező."
              @change="errors.name = false"
              :danger="errors.name"
            ></vs-input>
          </vs-col>

          <vs-col vs-w="4" vs-type="flex" vs-justify="center" vs-align="center">
            <vs-input
              v-model="customerData.customerPostalCode"
              danger-text="Az irányítószám megadása kötelező"
              @change="errors.postalcode = false"
              :danger="errors.postalcode"
              label="Irányítószám"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col
            v-if="parseInt(customerData.shippingMethod) === 6"
            vs-w="4"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vs-select
              autocomplete
              placeholder="Válasszon várost"
              label="Város"
              v-model="customerData.customerCity"
              @change="
                errors.city = false;
                checkPriceLimit();
                setupDeliveryDateOnLocation();
              "
              :danger="errors.city"
            >
              <vs-select-item
                :key="index"
                :value="location.LocationName"
                :text="location.LocationName"
                v-for="(location, index) in locationList"
              />
            </vs-select>
          </vs-col>
          <vs-col v-else vs-w="4" vs-type="flex" vs-justify="center" vs-align="center">
            <vs-input
              placeholder="Írja be a lakhelyét"
              label="Város"
              v-model="customerData.customerCity"
              danger-text="A város megadása kötelező"
              @change="errors.city = false"
              :danger="errors.city"
            >
            </vs-input>
          </vs-col>
          <vs-col vs-w="8" vs-type="flex" vs-justify="center" vs-align="center">
            <vs-input
              v-model="customerData.customerAddress"
              @change="errors.address = false"
              :danger="errors.address"
              danger-text="A cím megadása kötelező."
              label="Megrendelő címe"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="6" vs-type="flex" vs-justify="center" vs-align="center">
            <vs-input
              v-model="customerData.customerPhone"
              label="Megrendelő telefonszáma"
              danger-text="A telefonszám megadása kötelező."
              @change="errors.phone = false"
              :danger="errors.phone"
            ></vs-input>
          </vs-col>
          <vs-col vs-w="6" vs-type="flex" vs-justify="center" vs-align="center">
            <vs-input
              v-model="customerData.customerEmail"
              label="Megrendelő e-mail címe"
              :danger="errors.email"
              danger-text="Adjon meg érvényes email címet."
              @change="checkMail()"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col
            v-if="setupDeliveryMethods()"
            vs-lg="4"
            vs-sm="6"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vs-select
              autocomplete
              placeholder="Válasszon átvételi módot"
              label="Átvételi mód"
              v-model="customerData.shippingMethod"
              :danger="errors.shipping"
              danger-text="Válasszon átvételi módot."
              @change="
                errors.shipping = false;
                checkPriceLimit();
                setupDeliveryDateOnLocation();
              "
            >
              <vs-select-item
                :key="index"
                :value="shipping.Id"
                :text="shipping.ShippingName"
                v-for="(shipping, index) in shippingList"
              />
            </vs-select>
          </vs-col>
          <vs-col
            v-if="!setupDeliveryMethods()"
            vs-lg="4"
            vs-sm="12"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vs-select
              placeholder="Válasszon átvételi módot"
              label="Átvételi mód"
              v-model="customerData.shippingMethod"
            >
              <vs-select-item
                :key="index"
                :value="shipping.Id"
                :text="shipping.ShippingName"
                v-for="(shipping, index) in shippingList"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="4" vs-sm="6" vs-type="flex" vs-justify="center" vs-align="center">
            <vs-select
              autocomplete
              placeholder="Válasszon fizetési módot"
              label="Fizetési mód"
              v-model="customerData.paymentMethod"
              :danger="errors.payment"
              danger-text="Válasszon fizetési módot."
              @change="errors.payment = false"
            >
              <vs-select-item
                :key="index"
                :value="payment.Id"
                :text="payment.PaymentName"
                v-for="(payment, index) in paymentList"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-sm="12" vs-lg="4" vs-type="flex" vs-justify="center" vs-align="center">
            <vs-input
              type="date"
              :value="deliveryFrom"
              :min="deliveryFrom"
              :max="deliveryTo"
              v-model="customerData.shippingDate"
              label="Átvétel ideje"
              :danger="errors.date"
              danger-text="Válasszon ki dátumot."
              @change="errors.date = false"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="12">
            <vs-row>
              <vs-textarea label="Megjegyzés" v-model="customerData.customerMessage"></vs-textarea>
            </vs-row>
            <vs-row>
              <vs-col>
                <vs-collapse type="margin">
                  <vs-collapse-item :style="{ maxHeight: '250px', overflowY: 'auto' }">
                    <div slot="header">Rendelés részletei</div>
                    <vs-row v-for="(orderItem, orderItemIndex) in cartContent" :key="orderItemIndex">
                      <vs-col vs-w="9"> {{ orderItem.ItemQty }} x {{ orderItem.ItemName }} </vs-col>
                      <vs-col vs-w="3" vs-type="flex" vs-align="right" vs-justify="flex-end">
                        {{ formatToPrice(orderItem.ItemPrice) }}
                      </vs-col>
                    </vs-row>
                    <vs-row v-if="parseInt(deliveryFee) > 0">
                      <vs-col vs-w="9">
                        <strong>Szállítási díj:</strong>
                      </vs-col>
                      <vs-col vs-w="3" vs-type="flex" vs-align="right" vs-justify="flex-end">
                        {{ formatToPrice(deliveryFee) }}
                      </vs-col>
                    </vs-row>
                    <vs-row v-if="parseInt(packingFee) > 0">
                      <vs-col vs-w="9">
                        <strong>Csomagolási díj:</strong>
                      </vs-col>
                      <vs-col vs-w="3" vs-type="flex" vs-align="right" vs-justify="flex-end">
                        {{ formatToPrice(packingFee) }}
                      </vs-col>
                    </vs-row>
                    <!-- <vs-row v-if="!customerData.hasEtelhordo">
                      <vs-col vs-w="9">
                        <strong>Ételhordó</strong>
                      </vs-col>
                      <vs-col vs-w="3" vs-type="flex" vs-align="right" vs-justify="flex-end">
                        {{ formatToPrice(250) }}
                      </vs-col>
                    </vs-row> -->
                    <vs-row>
                      <vs-col vs-w="9">
                        <strong>Összesen:</strong>
                      </vs-col>
                      <vs-col vs-w="3" vs-type="flex" vs-align="right" vs-justify="flex-end">
                        {{ formatToPrice(parseInt(customerData.customerTotal) + parseInt(deliveryFee)) }}
                      </vs-col>
                    </vs-row>
                  </vs-collapse-item>
                </vs-collapse>
              </vs-col>
            </vs-row>
            <!-- <vs-row vs-type="flex" vs-justify="center" vs-align="center">
              <vs-checkbox v-model="customerData.hasEtelhordo">Saját dobozt használok
              </vs-checkbox>
            </vs-row> -->
            <vs-row vs-type="flex" vs-justify="center" vs-align="center">
              <vs-checkbox v-model="saveCustomerData" :disabled="checkConsent()"
                >Adatok mentése későbbi felhasználásra
              </vs-checkbox>
            </vs-row>
            <vs-row
              v-if="parseInt(customerData.paymentMethod) === 5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <vs-checkbox v-model="dataHandling">Az adattovábbítási nyilatkozatot elfogadom</vs-checkbox>
              <vs-row>
                <p class="dataHandling">
                  Tudomásul veszem, hogy a(z) CRONGA TEAM Kft. (5123 Jászárokszállás, Hattyú utca 9.) adatkezelő által
                  a(z) https://etelrendeles.beregszaszietterem.hu felhasználói adatbázisában tárolt alábbi személyes
                  adataim átadásra kerülnek az OTP Mobil Kft., mint adatfeldolgozó részére. Az adatkezelő által
                  továbbított adatok köre az alábbi: név, cím, telefonszám, email cím. Az adatfeldolgozó által végzett
                  adatfeldolgozási tevékenység jellege és célja a SimplePay Adatkezelési tájékoztatóban, az alábbi
                  linken tekinthető meg:
                  <a href="http://simplepay.hu/vasarlo-aff" target="_blank" class="spLink"
                    >http://simplepay.hu/vasarlo-aff</a
                  >
                </p>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-row
            v-show="parseInt(customerData.customerTotal) < parseInt(minimumOrder)"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <p style="color: red">
              A rendelés összege ({{ customerData.customerTotal }} HUF) nem éri el a választott város minimum rendelési
              összegét ({{ minimumOrder }} HUF).
            </p>
          </vs-row>
          <vs-col vs-w="12" vs-type="flex" vs-justify="center">
            <vs-button
              @click="validateOrder()"
              :disabled="blockOrder || (parseInt(customerData.paymentMethod) === 5 && !dataHandling)"
            >
              Rendelés küldése
            </vs-button>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" vs-type="flex">
          <vs-col vs-justify="center" align="center">
            <img
              :src="require('@/assets/images/logo/simplepay_bankcard_logos_left.jpg')"
              height="50"
              alt="SimplePay Logo"
              id="spLogo"
            />
          </vs-col>
        </vs-row>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup title="Rendelés elküldve" :active.sync="orderDone">
        <vs-row vs-type="flex" vs-justify="center">
          <h3>Sikeres rendelés, köszönjük a vásárlást!</h3>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center">
          <vs-icon icon="check" color="success" size="50px"></vs-icon>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center">
          <p>Ha ízlenek az ételeink, kedvelj minket facebookon!</p>
          <vs-row vs-type="flex" vs-justify="center">
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fberegszaszi.etterem&tabs=timeline&width=0&height=0&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
              width="0"
              height="0"
              style="border: none; overflow: hidden"
              scrolling="no"
              frameborder="0"
              allowfullscreen="true"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            ></iframe>
          </vs-row>
        </vs-row>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { axiosInstance } from "@/main";
import AnimatedNumber from "animated-number-vue";
import dayjs from "dayjs";

export default {
  name: "cart",
  props: ["itemToCart", "menuSettings"],
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      showDetails: false,
      orderDetails: false,
      orderDone: false,
      saveCustomerData: false,
      hasEtelhordo: false,
      dataHandling: false,
      cartContent: [],
      locationList: [],
      paymentList: [],
      shippingList: [],
      deliveryFrom: dayjs().format("YYYY-MM-DD"),
      deliveryTo: "2077-12-31",
      allowedShippings: 1,
      allowedHour: 20,
      allowedDeliveryTime: "today",
      blockOrder: false,
      minimumOrder: 0,
      deliveryFee: 0,
      packingFee: 0,
      cartMixture: "",
      regEx:
        /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      customerData: {
        customerName: this.$store.state.customer.name ? this.$store.state.customer.name : "",
        customerPostalCode: this.$store.state.customer.postalCode ? this.$store.state.customer.postalCode : "",
        customerCity: this.$store.state.customer.city ? this.$store.state.customer.city : "",
        customerAddress: this.$store.state.customer.address ? this.$store.state.customer.address : "",
        customerEmail: this.$store.state.customer.email ? this.$store.state.customer.email : "",
        customerPhone: this.$store.state.customer.phone ? this.$store.state.customer.phone : "",
        paymentMethod: "",
        shippingMethod: "",
        shippingDate: "",
        customerTotal: 0,
        customerMessage: "",
      },
      errors: {
        name: false,
        postalcode: false,
        city: false,
        address: false,
        email: false,
        phone: false,
        payment: false,
        shipping: false,
        date: false,
      },
    };
  },
  watch: {
    itemToCart() {
      this.setupShit(this.itemToCart);
      this.cartContent.push(this.itemToCart);
    },
    menuSettings() {
      if (!this.allowedShippings || this.cartContent.length <= 0) this.allowedShippings = this.menuSettings.pickupOnly;
      if (this.allowedHour === -1 || this.cartContent.length <= 0) this.allowedHour = this.menuSettings.maxHour;
      if (!this.allowedDeliveryTime || this.cartContent.length <= 0)
        this.allowedDeliveryTime = this.menuSettings.closestDelivery;
    },
    "customerData.shippingMethod": function () {
      // Call checkPriceLimit whenever the shipping method changes
      this.checkPriceLimit();
    },
    "customerData.customerCity": function () {
      // Call checkPriceLimit whenever the customer city changes
      this.checkPriceLimit();
    },
  },
  methods: {
    formatToPrice(value) {
      return `${Number(value).toFixed(0)} HUF`;
    },
    deleteFromCart(index) {
      let self = this;
      self.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Megerősítés`,
        text: "Valóban törölni kívánja a tételt?",
        acceptText: "Igen",
        cancelText: "Nem",
        accept: function () {
          self.cartContent.splice(index, 1);
          if (self.cartContent.length === 0) {
            self.allowedPayments = "";
            self.blockOrder = false;
            self.cartMixture = "";
            self.getTotalPrice();
          }
          self.checkCartContentMixture();
          self.$emit("deleteFromCart");
        },
      });
    },
    deleteAddon(cartIndex, itemIndex) {
      let self = this;
      self.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Megerősítés`,
        text: "Valóban törölni kívánja a tételt?",
        acceptText: "Igen",
        cancelText: "Nem",
        accept: function () {
          self.cartContent[cartIndex].ItemAddons.splice(itemIndex, 1);
        },
      });
    },
    getPrice(item) {
      return item.ItemPrice * item.ItemQty;
    },
    decrement(index) {
      if (parseInt(this.cartContent[index].ItemQty) === 1) this.deleteFromCart(index);
      else this.cartContent[index].ItemQty--;
    },
    getTotalPrice() {
      let self = this;
      let sum = 0;
      let packingFee = 0;

      for (let i = 0; i < self.cartContent.length; i++) {
        sum += self.cartContent[i].ItemQty * self.cartContent[i].ItemPrice;
        if (self.cartContent[i].ItemAddons.length > 0)
          sum += self.cartContent[i].ItemAddons.reduce((elem, { AddonPrice }) => elem + parseInt(AddonPrice), 0);

        // Check if the item name matches any of the specified items and add packing fee accordingly
        const itemName = self.cartContent[i].ItemName;

        if (self.cartContent[i].ParentId == 128) {
          // Check for salad items (contains "saláta" and "kg")
          if (itemName.toLowerCase().includes("saláta") && itemName.toLowerCase().includes("kg")) {
            packingFee += 400 * self.cartContent[i].ItemQty;
          }
          // Check for meat items (doesn't contain "saláta" or "kg")
          else if (!itemName.toLowerCase().includes("saláta") && !itemName.toLowerCase().includes("kg")) {
            packingFee += 30 * self.cartContent[i].ItemQty;
          }
        }
      }

      // Update the packing fee
      this.packingFee = packingFee;

      // Add the packing fee to the total sum
      sum += packingFee;

      this.customerData.customerTotal = sum;
      return sum;
    },
    placeOrder() {
      // ha heti menüajánlatos, akkor a levesek számának meg kell egyeznie a főételek számával
      let self = this;
      let leves = 0;
      let foetel = 0;
      const levesKategoriak = ["leves"];
      const foetelKategoriak = [
        "saláták",
        "halak",
        "szárnyasból készült",
        "sertésből készült",
        "marhából és bárányból készült",
        "tészták és veget",
        "vadból készült ételek",
      ];
      for (let i = 0; i < self.cartContent.length; i++) {
        if (self.cartContent[i]?.MenuName?.toLowerCase().includes("heti menü aján")) {
          // heti menü esetében azt is kell nézni, hogy csak hétköznap lehet ilyet rendelni
          const today = new Date().getDay();
          if (today == 0 || today == 6) {
            this.$vs.notify({
              title: "Heti menü hiba",
              text: `A heti menü ajánlatból csak hétköznap lehet rendelni!`,
              color: "warning",
              position: "top-right",
            });
            return;
          }
          // heti menüről van szó, számoljuk a leveseket és a főételeket
          const itemCategory = self.cartContent[i].ItemCategoryName.toLowerCase();
          const itemQty = parseInt(self.cartContent[i].ItemQty) || 1;
          if (levesKategoriak.some((cat) => itemCategory.includes(cat))) leves += itemQty;
          if (foetelKategoriak.some((cat) => itemCategory.includes(cat))) foetel += itemQty;
          //if (self.cartContent[i].ItemCategoryName.toLowerCase().includes("leves")) leves++;
        }
      }
      if (leves != foetel) {
        this.$vs.notify({
          title: "Heti menü hiba",
          text: `A heti menü ajánlatban a levesek (${leves}) és főételek (${foetel}) száma nem egyezik! Kérjük, egyeztesse a mennyiséget.`,
          color: "warning",
          position: "top-right",
        });
        return;
      }

      if (this.hasExpiredTodayOrderItem()) {
        this.showMaxOrderHourWarning();
        return;
      }

      this.showDetails = false;
      this.orderDetails = true;
      this.customerData.shippingMethod = 6;
      this.checkPriceLimit();
    },
    processOrder() {
      let self = this;
      let orderData = {};

      if (this.hasExpiredTodayOrderItem()) {
        this.showMaxOrderHourWarning();
        return;
      }

      self.$vs.loading({ type: "border", text: "Feldolgozás..." });
      orderData.customerData = this.customerData;
      orderData.purchaseData = JSON.stringify(this.cartContent);
      orderData.deliveryFee = self.deliveryFee;
      orderData.packingFee = self.packingFee;

      axiosInstance
        .put("public/placeOrderController.php", orderData)
        .then((resp) => {
          self.$vs.notify({
            title: "Rendszerüzenet",
            position: "top-right",
            text: resp.data.status === "OK" ? "Sikeres rendelés." : "Sikertelen rendelés. " + resp.data.message,
            color: resp.data.status === "OK" ? "success" : "danger",
            icon: resp.data.status === "OK" ? "check_box" : "error",
          });
          if (self.saveCustomerData) {
            self.$store.commit("saveCustomerData", {
              customerName: self.customerData.customerName,
              customerPostalCode: self.customerData.customerPostalCode,
              customerCity: self.customerData.customerCity,
              customerAddress: self.customerData.customerAddress,
              customerPhone: self.customerData.customerPhone,
              customerEmail: self.customerData.customerEmail,
            });
          }
          self.orderDetails = false;
          self.orderDone = true;
          self.cartContent = [];
          self.customerData.customerTotal = 0;
          self.$vs.loading.close();
          self.$emit("orderDone");
        })
        .catch((err) => {
          self.$vs.loading.close();
          if (err.response.status === 401) self.$root.exterminatus();
          else {
            self.$vs.notify({
              title: "Rendszerüzenet",
              position: "top-right",
              text: err.response.data.message,
              color: "danger",
              icon: "error",
            });
          }
        });
    },
    processCardTransaction() {
      let self = this;
      let orderData = {};

      if (this.hasExpiredTodayOrderItem()) {
        this.showMaxOrderHourWarning();
        return;
      }

      orderData.customerData = this.customerData;
      orderData.purchaseData = JSON.stringify(this.cartContent);

      if (self.saveCustomerData) {
        self.$store.commit("saveCustomerData", {
          customerName: self.customerData.customerName,
          customerPostalCode: self.customerData.customerPostalCode,
          customerCity: self.customerData.customerCity,
          customerAddress: self.customerData.customerAddress,
          customerPhone: self.customerData.customerPhone,
          customerEmail: self.customerData.customerEmail,
        });
      }

      axiosInstance
        .post("public/processCardTransaction.php", orderData)
        .then((resp) => {
          window.location.replace(resp.data.url);
        })
        .catch((err) => {
          if (err.response.status === 401) self.$root.exterminatus();
          else {
            self.$vs.notify({
              title: "Rendszerüzenet",
              position: "top-right",
              text: err.response.data.message,
              color: "danger",
              icon: "error",
            });
          }
        });
    },
    getDeliveryData() {
      let self = this;
      return Promise.all([
        axiosInstance.get("public/deliveryLocationController.php"),
        axiosInstance.get("public/paymentController.php"),
        axiosInstance.get("public/shippingController.php"),
      ]).then((results) => {
        self.locationList = results[0].data.responseData;
        self.paymentList = results[1].data.responseData;
        self.shippingList = results[2].data.responseData;
        console.log(self.shippingList[0].id);
        console.log(self.locationList);
        console.log(self.shippingList);
      });
    },
    validateOrder() {
      let errors = 0;

      if (this.customerData.customerName.length === 0) {
        this.errors.name = true;
        errors++;
      }
      if (this.customerData.customerCity.length === 0 && this.customerData.shippingMethod === this.shippingList[1].Id) {
        this.errors.city = true;
        errors++;
      }

      if (
        this.customerData.customerPostalCode.length === 0 &&
        this.customerData.shippingMethod === this.shippingList[1].Id
      ) {
        this.errors.postalcode = true;
        errors++;
      }

      if (this.customerData.customerCity.length === 0 && this.customerData.shippingMethod === this.shippingList[1].Id) {
        this.errors.city = true;
        errors++;
      }

      if (this.customerData.customerCity.length === 0) {
        this.errors.city = true;
        errors++;
      }

      if (
        this.customerData.customerAddress.length === 0 &&
        this.customerData.shippingMethod === this.shippingList[1].Id
      ) {
        this.errors.address = true;
        errors++;
      }

      if (this.customerData.paymentMethod.length === 0) {
        this.errors.payment = true;
        errors++;
      }

      if (this.customerData.shippingMethod.length === 0) {
        this.errors.shipping = true;
        errors++;
      }

      if (this.customerData.shippingDate.length === 0) {
        this.errors.date = true;
        errors++;
      }
      if (this.customerData.customerPhone.length === 0) {
        this.errors.phone = true;
        errors++;
      }

      if (this.customerData.customerEmail.length > 0) this.checkMail();
      if (this.errors.email) errors++;

      if (errors === 0) {
        if (this.hasExpiredTodayOrderItem()) {
          this.showMaxOrderHourWarning();
          return;
        }

        // Directly process the order based on payment method
        if (parseInt(this.customerData.paymentMethod) === 5) {
          this.processCardTransaction();
        } else {
          this.processOrder();
        }
      }
    },
    checkMail() {
      this.errors.email =
        this.customerData.customerEmail.length === 0 || !this.regEx.test(this.customerData.customerEmail);
    },
    hasExpiredTodayOrderItem() {
      if (this.customerData.shippingDate !== dayjs().format("YYYY-MM-DD")) return false;

      return this.cartContent.some((cartItem) => {
        const maxHour = parseInt(cartItem.MaxOrderHour);

        return !isNaN(maxHour) && maxHour >= 0 && dayjs().hour() >= maxHour;
      });
    },
    showMaxOrderHourWarning() {
      this.$vs.notify({
        color: "warning",
        title: "A rendelési idő lejárt",
        text: "A kosárban lévő tétel rendelési ideje lejárt, ezért a rendelés már nem küldhető be.",
        position: "top-right",
      });
    },
    checkPriceLimit() {
      let locationLimit = this.locationList.find((elem) => elem.LocationName === this.customerData.customerCity);
      if (locationLimit) {
        this.blockOrder =
          parseInt(this.customerData.customerTotal) < parseInt(locationLimit.MinimumOrder) &&
          this.customerData.shippingMethod === this.shippingList[1].Id;
        this.minimumOrder = locationLimit.MinimumOrder;
        // this.shippingList[1].Id nem működik 6 lett helyette, hiába próbálom órák óta előhívni a rendes értékét ott bassza meg az anyját
        this.deliveryFee = this.customerData.shippingMethod == 6 ? locationLimit.DeliveryPrice : 0;
      }
    },
    setupShit(item) {
      if (item.MenuDate && (this.cartMixture.length === 0 || this.cartMixture === "daily")) this.cartMixture = "daily";
      else if (!item.MenuDate && (this.cartMixture.length === 0 || this.cartMixture === "simple"))
        this.cartMixture = "simple";
      else this.cartMixture = "mixed";

      switch (this.cartMixture) {
        case "daily":
          this.customerData.shippingDate =
            !this.customerData.shippingDate || dayjs(this.customerData.shippingDate) > dayjs(item.MenuDate)
              ? item.MenuDate
              : this.customerData.shippingDate;
          this.deliveryFrom = this.deliveryTo = dayjs(this.customerData.shippingDate).format("YYYY-MM-DD");
          break;
        case "simple":
        case "mixed":
          if (this.allowedDeliveryTime === "today") {
            if (dayjs().hour() < parseInt(this.allowedHour)) {
              this.deliveryFrom = dayjs().format("YYYY-MM-DD");
              this.customerData.shippingDate = dayjs().format("YYYY-MM-DD");
            } else {
              this.deliveryFrom = dayjs().add(1, "day").format("YYYY-MM-DD");
              this.customerData.shippingDate = dayjs().add(1, "day").format("YYYY-MM-DD");
            }
          }
          if (this.allowedDeliveryTime === "next_day") {
            if (dayjs().hour() < parseInt(this.allowedHour)) {
              this.deliveryFrom = dayjs().add(1, "day").format("YYYY-MM-DD");
              this.customerData.shippingDate = dayjs().add(1, "day").format("YYYY-MM-DD");
            } else {
              this.deliveryFrom = dayjs().add(2, "day").format("YYYY-MM-DD");
              this.customerData.shippingDate = dayjs().add(2, "day").format("YYYY-MM-DD");
            }
          }
          this.deliveryTo = "2077-12-31";
          break;
      }
    },
    setupDeliveryMethods() {
      if (
        parseInt(this.allowedShippings) === 0 ||
        (parseInt(this.allowedShippings) === 1 && dayjs().format("YYYY-MM-DD") < this.customerData.shippingDate)
      )
        return true;
      else return false;
    },
    checkConsent() {
      let b = localStorage.getItem("vue-cookie-accept-decline-cookiePanel");
      return b !== "accept";
    },
    setupDeliveryDateOnLocation() {
      switch (this.cartMixture) {
        case "mixed":
        case "simple":
          // böszörményen kívül csak másnap
          if (parseInt(this.cartContent[0].MenuId) === 30) {
            break;
          } else if (
            parseInt(this.customerData.shippingMethod) === 6 &&
            this.customerData.customerCity &&
            this.customerData.customerCity !== "Hajdúböszörmény" &&
            this.customerData.shippingDate === dayjs().format("YYYY-MM-DD") &&
            this.menuSettings.closestDelivery === "today"
          ) {
            this.customerData.shippingDate = dayjs().add(1, "day").format("YYYY-MM-DD");
            this.deliveryFrom = dayjs().add(1, "day").format("YYYY-MM-DD");
            this.$vs.dialog({
              color: "warning",
              title: "Figyelmeztetés",
              text: "Hajdúböszörmény városán kívül csak másnapra kérhet házhozszállítást. A rendelési idő dátuma átállításra került a holnapi napra.",
              acceptText: "Rendben",
            });
          } else if (
            parseInt(this.customerData.shippingMethod) === 5 ||
            (this.customerData.customerCity && this.customerData.customerCity === "Hajdúböszörmény")
          ) {
            this.customerData.shippingDate = dayjs().format("YYYY-MM-DD");
            this.deliveryFrom = dayjs().format("YYYY-MM-DD");
          }
          break;
        case "daily":
          // napi menü aznap csak személyes
          if (
            parseInt(this.customerData.shippingMethod) === 6 &&
            this.customerData.shippingDate === dayjs().format("YYYY-MM-DD") &&
            this.cartContent.length === 1
          ) {
            if (this.customerData.customerCity && this.customerData.customerCity !== "Hajdúböszörmény") {
              this.blockOrder = true;
              this.$vs.dialog({
                color: "warning",
                title: "Figyelmeztetés",
                text: "Hajdúböszörmény városán kívül csak másnapra kérhet házhozszállítást. Kérem válassza a Személyes átvételi módot",
                acceptText: "Rendben",
              });
            } else this.blockOrder = false;
          } else this.blockOrder = false;
          break;
      }
    },
    checkCartContentMixture() {
      let mix = "";
      this.cartContent.forEach((elem) => {
        if (elem.MenuDate && (mix === "daily" || mix === "")) mix = "daily";
        else if (!elem.MenuDate && (mix === "simple" || mix === "")) mix = "simple";
        else mix = "mixed;";
      });
      this.cartMixture = mix;
    },
  },
  created() {
    this.getDeliveryData().then(() => {
      // After data is loaded, you might want to check the price limit
      this.checkPriceLimit();
    });
  },
};
</script>

<style scoped>
li .vs-row {
  margin: 5px 0;
}

h4 {
  margin-bottom: 5px;
}

.cartButton {
  margin: 0 2px;
}

.priceTag {
  margin-right: 10px;
  font-weight: bold;
  font-size: 14px;
}

.vs-input {
  margin: 5px 2px;
  width: 100%;
}

.con-vs-checkbox {
  margin: 5px;
}

.vs-collapse .vs-collapse-item--content {
  min-height: 100px !important;
}

.card-move {
  opacity: 1;
  transition: all 0.5s;
}

.cartCard {
  position: relative;
  top: 0;
  right: 5px;
  box-shadow: 0 0 0 1px inset #000;
  background-color: #fff;
  border-radius: 10px 0 0 10px;
  padding: 5px 10px 5px 10px;
  transition: 0.2s all linear;
}

.cartCard:hover {
  position: relative;
  top: -5px;
  border-radius: 10px 0 0 10px;
  padding: 5px 10px 5px 10px;
}

.cartHasItem {
  background-color: #a4e7a4 !important;
}

.dataHandling {
  text-align: justify;
  font-size: 10px;
}

.vs-con-textarea {
  margin-bottom: 0 !important;
}

#spLogo {
  margin-top: 15px;
  max-width: 100%;
}

.spLink {
  font-weight: bold;
  color: red;
}
</style>
